import React from 'react';
import { getIconsByStyle, getCartIcon, getSpinnerIcon } from '../../assets/creator/icons';
import { generateClassStyles } from '../../utils/svgUtils/generateClassStyles';

const CurrentSvgSprite = ({ iconStyle, cartIconStyle, spinnerIconStyle, colorSettings }) => (
    <svg style={{ display: "none" }}>
        <defs dangerouslySetInnerHTML={{ __html: generateClassStyles(colorSettings) }} />
        {getIconsByStyle(iconStyle)}
        {getCartIcon(iconStyle, cartIconStyle)}
        {getSpinnerIcon(iconStyle, spinnerIconStyle)}
    </svg>
);

export default CurrentSvgSprite;